import { render } from "./safareigTermal.vue?vue&type=template&id=1de5c0ea"
import script from "./safareigTermal.vue?vue&type=script&lang=js"
export * from "./safareigTermal.vue?vue&type=script&lang=js"

import "./safareigTermal.vue?vue&type=style&index=0&id=1de5c0ea&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__